import React from 'react'
import styles from './Feedback.module.less'
import CloseCircleFilled from '@ant-design/icons/lib/icons/CloseCircleFilled'
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled'

type FeedbackProps = {
    isCorrect: boolean
    correctAnswer: string
    feedback: string
}

export const Feedback: React.FC<FeedbackProps> = ({ isCorrect, correctAnswer, feedback }) => {
    return (
        <div className={styles.feedbackContainer}>
            <div className={styles.header}>
                {isCorrect ? (
                    <>
                        <CheckCircleFilled className={styles['correct-icon']} />
                        <span className={styles.headerText}>Your answer is correct</span>
                    </>
                ) : (
                    <>
                        <CloseCircleFilled className={styles['incorrect-icon']} />
                        <span className={styles.headerText}>Your answer is incorrect</span>
                    </>
                )}
            </div>

            {!isCorrect && correctAnswer && (
                <div className={styles.correctAnswer}>
                    <span className={styles.label}>Correct answer: </span>
                    <span className={styles.answer}>{correctAnswer}</span>
                </div>
            )}

            <div className={styles.divider} />

            <div className={styles.feedbackSection}>
                <span className={styles.feedbackLabel}>Feedback: </span>
                <span className={styles.feedbackText}>{feedback}</span>
            </div>
        </div>
    )
}
